import Vue from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';

const req = require.context('@/assets/svgIcons', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);

Vue.component('svg-icon', SvgIcon);


// WEBPACK FOOTER //
// ./src/utils/setIcon.js